import type { InterfaceDefinition } from "..";
import { ErrorSpreadsheetResult } from "../../../util/spreadsheet-data-utils";

export type IfDefinition = {
  interfaceDefinition: InterfaceDefinition;
};

export type GetIfDefinitionForReferenceResult = ErrorSpreadsheetResult & {
  /**
   * The requested boundary type.
   */
  bdryType: string;

  /**
   * The requested boundary ID.
   */
  bdryId: string;

  /**
   * Destination Dip By Region.
   */
  dstDipByRgn?: string;

  /**
   * Destination Outbound ID.
   */
  dstOtbdId?: string;

  /**
   * Source Inbound ID.
   */
  srcInbdId?: string;

  /**
   * The results of this get_if_definition_history response body.
   */
  ifDefinition: IfDefinition;
};

export type GetIfDefinitionForReferenceResponse = {
  /**
   * Result List.
   */
  resultList: GetIfDefinitionForReferenceResult[];
};
